var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-base',{class:_vm.componentClasses,attrs:{"submit-type":"button"},on:{"click":function($event){return _vm.clicked()}}},[_c('text-content',{attrs:{"size":'sm1',"decoration":'underline',"line-height":'multi',"weight":_vm.weight}},[_vm._v(" "+_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }